/**
 * Helpers for creating Documents instance
 */

import type { IBaseNotary } from "../../BaseNotaryFactory";
import type { Document } from "le-coffre-resources/dist/Notary";
import type { ApiPayload } from "../../../../types";
import type {
	IGetDocumentsparams,
	IGetDocumentByUidParams,
	IPutDocumentsParams,
	IPostDocumentsBatchResponse,
	IInotPushResponse,
} from "../Documents";
import {
	createGetMethod,
	createPostMethod,
	createPostBatchMethod,
	createGetByUidMethod,
	createUploadDocumentMethod,
	createUploadDocumentsMethod,
	createRefuseMethod,
	createPutMethod,
	createDeleteMethod,
	createResendRequestMethod,
	createResendRequestBatchMethod,
	createPushToInotMethod,
} from "./documentsMethodsHelpers";

export interface DocumentsInstance {
	get(q: IGetDocumentsparams): Promise<Document[]>;
	post(body: ApiPayload): Promise<Document>;
	postBatch(documents: ApiPayload[]): Promise<IPostDocumentsBatchResponse>;
	getByUid(uid: string, q?: IGetDocumentByUidParams): Promise<Document>;
	uploadDocument(documentUid: string, file: File): Promise<Document>;
	uploadDocuments(documentUid: string, files: File[]): Promise<Document>;
	refuse(uid: string, refused_reason: string): Promise<Document>;
	put(uid: string, body: IPutDocumentsParams): Promise<Document>;
	delete(uid: string): Promise<Document>;
	resendRequest(uid: string): Promise<{ message: string; document: Document }>;
	resendRequestBatch(documentUids: string[]): Promise<{ message: string; documents: Document[] }>;
	pushToInot(uid: string): Promise<IInotPushResponse>;
}

/**
 * Create Documents instance with all methods
 */
export function createDocumentsInstance(baseNotary: IBaseNotary): DocumentsInstance {
	const baseUrl = baseNotary.namespaceUrl.concat("/documents");

	return {
		get: createGetMethod(baseNotary, baseUrl),
		post: createPostMethod(baseNotary, baseUrl),
		postBatch: createPostBatchMethod(baseNotary, baseUrl),
		getByUid: createGetByUidMethod(baseNotary, baseUrl),
		uploadDocument: createUploadDocumentMethod(baseNotary, baseUrl),
		uploadDocuments: createUploadDocumentsMethod(baseNotary, baseUrl),
		refuse: createRefuseMethod(baseNotary, baseUrl),
		put: createPutMethod(baseNotary, baseUrl),
		delete: createDeleteMethod(baseNotary, baseUrl),
		resendRequest: createResendRequestMethod(baseNotary, baseUrl),
		resendRequestBatch: createResendRequestBatchMethod(baseNotary, baseUrl),
		pushToInot: createPushToInotMethod(baseNotary, baseUrl),
	};
}
